interface Props {
  errors: string[];
}

const ValidationPanel = ({ errors }: Props) => {
  if (errors.length === 0) return null;

  return (
    <div className="section-card mb-3 validation-panel" style={{ borderColor: '#f8d7da', background: '#fff5f5' }}>
      <div className="section-title" style={{ color: '#e74c3c' }}>
        ⚠ Schedule Issues ({errors.length})
      </div>
      {errors.map((err, i) => (
        <div key={i} className="alert-item">
          <span>•</span>
          <span>{err}</span>
        </div>
      ))}
    </div>
  );
};

export default ValidationPanel;
